// @flow

export default (state: Object): Array<Object> => state.mapModule.featureOperations
